var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgApply(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 67.873,
    height: 67.875,
    viewBox: "0 0 67.873 67.875",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 67.873,
    height: 67.875,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "resume",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "resume-2",
    "data-name": "resume",
    transform: "translate(-0.007)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3233",
    "data-name": "Group 3233",
    transform: "translate(0.007)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3232",
    "data-name": "Group 3232"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14929",
    "data-name": "Path 14929",
    d: "M54.89,19.72a1.326,1.326,0,0,0,1.326-1.326V3.977A3.982,3.982,0,0,0,52.239,0H3.984A3.982,3.982,0,0,0,.007,3.977V63.9a3.982,3.982,0,0,0,3.977,3.977H52.239A3.982,3.982,0,0,0,56.216,63.9V54.131a1.326,1.326,0,0,0-2.651,0V63.9a1.327,1.327,0,0,1-1.326,1.326H3.984A1.327,1.327,0,0,1,2.658,63.9V3.977A1.327,1.327,0,0,1,3.984,2.651H52.239a1.327,1.327,0,0,1,1.326,1.326V18.394A1.326,1.326,0,0,0,54.89,19.72Z",
    transform: "translate(-0.007)",
    fill: "#63b1af"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3235",
    "data-name": "Group 3235",
    transform: "translate(15.915 7.159)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3234",
    "data-name": "Group 3234"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14930",
    "data-name": "Path 14930",
    d: "M132.2,54a12.19,12.19,0,0,0-8.367,21.061,1.312,1.312,0,0,0,.142.133,12.173,12.173,0,0,0,16.45,0,1.326,1.326,0,0,0,.142-.133A12.19,12.19,0,0,0,132.2,54Zm0,21.741a9.494,9.494,0,0,1-5.766-1.945,6.628,6.628,0,0,1,11.531,0A9.494,9.494,0,0,1,132.2,75.741Zm-2.121-10.075V64.8a2.121,2.121,0,0,1,4.242,0v.862a2.121,2.121,0,0,1-4.242,0Zm9.8,6.189a9.2,9.2,0,0,0-3.906-3.274,4.747,4.747,0,0,0,1-2.915V64.8a4.772,4.772,0,0,0-9.545,0v.862a4.747,4.747,0,0,0,1,2.915,9.2,9.2,0,0,0-3.906,3.274,9.545,9.545,0,1,1,15.362,0Z",
    transform: "translate(-120.007 -54)",
    fill: "#63b1af"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3237",
    "data-name": "Group 3237",
    transform: "translate(26.786 58.065)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3236",
    "data-name": "Group 3236"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14931",
    "data-name": "Path 14931",
    d: "M210.491,438h-7.159a1.326,1.326,0,0,0,0,2.651h7.159a1.326,1.326,0,1,0,0-2.651Z",
    transform: "translate(-202.007 -438)",
    fill: "#63b1af"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3239",
    "data-name": "Group 3239",
    transform: "translate(15.12 50.641)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3238",
    "data-name": "Group 3238"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14932",
    "data-name": "Path 14932",
    d: "M134.157,382H115.333a1.326,1.326,0,0,0,0,2.651h18.825a1.326,1.326,0,1,0,0-2.651Z",
    transform: "translate(-114.007 -382)",
    fill: "#63b1af"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3241",
    "data-name": "Group 3241",
    transform: "translate(15.12 43.217)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3240",
    "data-name": "Group 3240"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14933",
    "data-name": "Path 14933",
    d: "M134.157,326H115.333a1.326,1.326,0,0,0,0,2.651h18.825a1.326,1.326,0,1,0,0-2.651Z",
    transform: "translate(-114.007 -326)",
    fill: "#63b1af"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3243",
    "data-name": "Group 3243",
    transform: "translate(9.456 35.793)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3242",
    "data-name": "Group 3242"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14934",
    "data-name": "Path 14934",
    d: "M73.551,270.388a1.325,1.325,0,1,0,.389.937A1.336,1.336,0,0,0,73.551,270.388Z",
    transform: "translate(-71.287 -270)",
    fill: "#63b1af"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3245",
    "data-name": "Group 3245",
    transform: "translate(9.456 43.217)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3244",
    "data-name": "Group 3244"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14935",
    "data-name": "Path 14935",
    d: "M73.551,326.388a1.325,1.325,0,1,0,.389.937A1.338,1.338,0,0,0,73.551,326.388Z",
    transform: "translate(-71.287 -326)",
    fill: "#63b1af"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3247",
    "data-name": "Group 3247",
    transform: "translate(9.456 50.641)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3246",
    "data-name": "Group 3246"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14936",
    "data-name": "Path 14936",
    d: "M73.551,382.388a1.325,1.325,0,1,0,.389.937A1.338,1.338,0,0,0,73.551,382.388Z",
    transform: "translate(-71.287 -382)",
    fill: "#63b1af"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3249",
    "data-name": "Group 3249",
    transform: "translate(15.12 35.793)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3248",
    "data-name": "Group 3248"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14937",
    "data-name": "Path 14937",
    d: "M134.157,270H115.333a1.326,1.326,0,0,0,0,2.651h18.825a1.326,1.326,0,1,0,0-2.651Z",
    transform: "translate(-114.007 -270)",
    fill: "#63b1af"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3251",
    "data-name": "Group 3251",
    transform: "translate(39.457 16.528)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3250",
    "data-name": "Group 3250"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14938",
    "data-name": "Path 14938",
    d: "M323.23,125.424a5.568,5.568,0,0,0-7.606,2.038l-16.683,28.895a1.328,1.328,0,0,0-.169.516L297.6,167.391a1.326,1.326,0,0,0,2.1,1.215l8.522-6.276a1.324,1.324,0,0,0,.362-.4l16.683-28.9A5.574,5.574,0,0,0,323.23,125.424Zm-22.661,39.25.613-5.493,3.837,2.215Zm6.383-5.223-5.052-2.917,13.387-23.188,5.052,2.917Zm16.02-27.747-1.307,2.263-5.052-2.917,1.307-2.263a2.916,2.916,0,0,1,5.052,2.917Z",
    transform: "translate(-297.589 -124.675)",
    fill: "#63b1af"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApply);
export default __webpack_public_path__ + "static/media/apply.1f15cffba8630acd7cd5bee28c04a32f.svg";
export { ForwardRef as ReactComponent };